import { DriverPersonalInfoType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/patchPersonalDriverData/driverPersonalInfoQuery.type';
import { driverPersonalInfoQueryFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/patchPersonalDriverData/driverPersonalInfoQueryFunction';
import { useMutation } from '@tanstack/react-query';

export const useDriverPersonalInfoQuery = () => {
  return useMutation({
    mutationFn: (params: DriverPersonalInfoType) =>
      driverPersonalInfoQueryFunction(params),
  });
};
